import React from "react";
import {
  BrowserRouter,
  Route,
  Routes as Switch,
  Navigate
} from "react-router-dom";
import { Box, CssBaseline, Toolbar } from "@mui/material";
import Navbar from "../../Components/Navbar";
import Dashboard from "../Dashboard/Dashboard";
import ProductsManagement from "../Productmanagement/ProductManagement";
import OrdersManagement from "../OrdesManagement/OrdersManagement";
import VendorLoginPage from "../VendorLogin/Login";
import Profile from "../Profile/Profile";
import Categories from "../CategoriesManagement/Categories";
import Coupons from "../Coupons/Coupons";
import ActivityLog from "../Logs/ActivityLog";
import LoginLogs from "../Logs/LoginLogs";
import PageNotFound from "../NotFound/PageNotFound";
import Notification from "../Notification/Notification";

// Layout component for authenticated pages
const MainLayout = ({ children }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <CssBaseline />
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1, p: 3, width: "100%" }}>
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Switch>
        {/* Public Route: Login */}
        <Route path="/login" element={<VendorLoginPage />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ProductsManagement />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <MainLayout>
                <OrdersManagement />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders/:requestId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <OrdersManagement />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Profile />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/categories"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Categories />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/coupons"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Coupons />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/coupons/:couponId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Coupons />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/activitylog"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ActivityLog />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/loginlogs"
          element={
            <ProtectedRoute>
              <MainLayout>
                <LoginLogs />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/notification"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Notification />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Redirect unknown routes to Login or Dashboard */}
        <Route path="*" element={<PageNotFound />} />
      </Switch>
    </BrowserRouter>
  );
};

export default AppRoutes;
